var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "top_content" } }, [
    !_vm.isHaseko
      ? _c("img", { attrs: { src: _vm.getImage("top/content/user.webp") } })
      : _vm._e(),
    _vm._v(" "),
    !_vm.isHaseko
      ? _c("section", [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          !_vm.isHaseko
            ? _c("div", [
                _c("a", { attrs: { href: "tel:0362761123" } }, [
                  _c("img", { attrs: { src: _vm.getImage("bunner/TEL.webp") } })
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("section", [
      _c("h2", [_vm._v("商品カテゴリから選ぶ")]),
      _vm._v(" "),
      _c("article", { staticClass: "category_list" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 1 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_WS.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 2 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_CB.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 3 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_SC.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 4 })
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.getImage("top/content/category_counter.webp")
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 5 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_tan.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 6 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_UC.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 7 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_SB.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 8 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_TV.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 9 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_BSDK.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 14 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_CL.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 15 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_NS.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        !_vm.isHaseko
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "category",
                  on: {
                    click: function($event) {
                      _vm.routeCategory({ cid: 16 })
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.getImage("top/content/category_Closet.webp")
                    }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isHaseko
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "category",
                  on: {
                    click: function($event) {
                      _vm.routeCategory({ cid: 17 })
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: _vm.getImage("top/content/category_WB.webp") }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 18 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_PS.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 19 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_floor.webp") }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "category",
              on: {
                click: function($event) {
                  _vm.routeCategory({ cid: 20 })
                }
              }
            },
            [
              _c("img", {
                attrs: { src: _vm.getImage("top/content/category_wall.webp") }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "other_btn",
          on: {
            click: function($event) {
              _vm.routeCategory()
            }
          }
        },
        [_vm._v("商品を選ぶ 〉〉")]
      )
    ]),
    _vm._v(" "),
    _c("section", { attrs: { id: "location_select" } }, [
      _c("h2", [_vm._v("場所から選ぶ")]),
      _vm._v(" "),
      _c("article", { attrs: { id: "location_list" } }, [
        _c("div", [
          _c("div", { staticClass: "location" }, [
            _c("img", {
              attrs: { src: _vm.getImage("top/content/floor_living.webp") }
            }),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v("リビング")]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 1 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("吊戸棚（フロート収納）")])]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 8 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("テレビボード")])]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 4 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("カウンター")])]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 5 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("棚板・フィラー")])]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 7 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("サイドボード")])]
                ),
                _vm._v(" "),
                !_vm.isHaseko
                  ? _c(
                      "li",
                      {
                        on: {
                          click: function($event) {
                            _vm.routeCategory({ cid: 16 })
                          }
                        }
                      },
                      [_c("a", [_vm._v("可動間仕切収納")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 18 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("シェルフ")])]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "location" }, [
            _c("img", {
              attrs: { src: _vm.getImage("top/content/floor_dining.webp") }
            }),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v("ダイニング")]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 6 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("カウンター下収納")])]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 7 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("サイドボード")])]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "location" }, [
            _c("img", {
              attrs: { src: _vm.getImage("top/content/floor_kitchen.webp") }
            }),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v("キッチン")]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 2 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("食器棚（カップボード）")])]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 15 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("隙間収納")])]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "location" }, [
            _c("img", {
              attrs: { src: _vm.getImage("top/content/floor_bath.webp") }
            }),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v("洗面所・バス")]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 1 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("吊戸棚（フロート収納）")])]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 15 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("隙間収納")])]
                ),
                _vm._v(" "),
                !_vm.isHaseko
                  ? _c(
                      "li",
                      {
                        on: {
                          click: function($event) {
                            _vm.routeCategory({ cid: 17 })
                          }
                        }
                      },
                      [_c("a", [_vm._v("洗面台")])]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "location" }, [
            _c("img", {
              attrs: { src: _vm.getImage("top/content/floor_den.webp") }
            }),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v("書斎・クローゼット")]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 9 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("本棚・デスク")])]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 14 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("クローゼット収納")])]
                ),
                _vm._v(" "),
                !_vm.isHaseko
                  ? _c(
                      "li",
                      {
                        on: {
                          click: function($event) {
                            _vm.routeCategory({ cid: 16 })
                          }
                        }
                      },
                      [_c("a", [_vm._v("可動間仕切収納")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 18 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("シェルフ")])]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "location" }, [
            _c("img", {
              attrs: { src: _vm.getImage("top/content/floor_entrance.webp") }
            }),
            _vm._v(" "),
            _c("div", [
              _c("div", [_vm._v("玄関・エントランス")]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  {
                    on: {
                      click: function($event) {
                        _vm.routeCategory({ cid: 3 })
                      }
                    }
                  },
                  [_c("a", [_vm._v("玄関収納")])]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.isHaseko
        ? _c("div", [
            _c("a", { attrs: { href: "tel:0362761123" } }, [
              _c("img", { attrs: { src: _vm.getImage("bunner/TEL.webp") } })
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("h2", [_vm._v("お客様に選ばれる3つの理由")]),
        _vm._v(" "),
        _c("dd-reason")
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isHaseko
      ? _c("div", [
          _c("a", { attrs: { href: "tel:0362761123" } }, [
            _c("img", { attrs: { src: _vm.getImage("bunner/TEL.webp") } })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { attrs: { id: "top_title" } }, [
      _c("p", { attrs: { id: "title_pc" } }, [
        _vm._v("サイズオーダー収納の専門店    mm/style（ミリスタイル）")
      ]),
      _vm._v(" "),
      _c("p", { attrs: { id: "title_sp" } }, [
        _vm._v("サイズオーダー収納の専門店"),
        _c("br"),
        _vm._v("mm/style（ミリスタイル）")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "article_photo president_photo" }, [
      _c("div", [
        _c("p", [
          _vm._v(
            "\n          収納家具を「ご希望のサイズ」でお作りいたします。"
          ),
          _c("br"),
          _vm._v(
            "\n          お客様の収納スペースに合わせて、ご希望のサイズをmm単位でオーダーできます！"
          ),
          _c("br"),
          _vm._v(
            "\n          トイレや冷蔵庫上の吊戸棚（フロート収納）、食器棚（カップボード）、壁面収納など、多くのご注文をいただいております。"
          ),
          _c("br"),
          _vm._v(
            "\n          「サイズの決め方が分からない」「どうやって買えば良いの？」といった方は、まずはご相談ください。"
          ),
          _c("br"),
          _vm._v(" "),
          _c("br")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-607970b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607970b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/top/DcTopContent.vue
// module id = null
// module chunks = 